module.exports = __webpack_public_path__ + "static/img/ucode.84a25b1d.png";